"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CircleBgBottomArrow = function CircleBgBottomArrow(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#FFFFFF' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#FFFFFF' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5001 16.84C14.2755 16.84 17.3361 13.7794 17.3361 10.004C17.3361 6.22856 14.2755 3.16797 10.5001 3.16797C6.72464 3.16797 3.66406 6.22856 3.66406 10.004C3.66406 13.7794 6.72464 16.84 10.5001 16.84Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5753 10.512C12.3833 10.32 12.0753 10.32 11.8873 10.512L10.9873 11.412V6.81596C10.9873 6.54796 10.7673 6.32796 10.4993 6.32796C10.2313 6.32796 10.0113 6.54796 10.0113 6.81596V11.412L9.1113 10.512C8.9193 10.32 8.6113 10.32 8.4233 10.512C8.2313 10.7 8.2313 11.012 8.4233 11.2L10.1553 12.932C10.2513 13.028 10.3753 13.076 10.4993 13.076C10.6233 13.076 10.7473 13.028 10.8433 12.932L12.5753 11.2C12.7673 11.012 12.7673 10.704 12.5753 10.512Z",
    fill: secondaryColor
  }));
};
var _default = exports["default"] = CircleBgBottomArrow;